import script from "./CheckoutForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutForm.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutForm.vue?vue&type=style&index=0&id=faf2a96a&lang=scss"

const __exports__ = script;

export default __exports__